import { Icon } from "@/components/ui/Icon";

type SpinnerProps = {
  className?: string;
};

export const Spinner = ({ className = "h-4 w-4" }: SpinnerProps) => {
  return <Icon icon="svg-spinners:90-ring-with-bg" className={className} />;
};
